var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-fake-scroll-box",class:{
       'mobile': _vm.isMobile
     }},[_c('div',{staticClass:"scroll-box"},[_vm._t("default")],2),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fake-scroll-track"},[_c('div',{staticClass:"fake-scroll-bar"})])
}]

export { render, staticRenderFns }